import { Injectable } from '@angular/core';
import { TMachineMaintenanceState } from '../reducers';
import { Store, select } from '@ngrx/store';
import {
  TFilterSelected,
  TListingFetchReason,
  TREQUEST_ADD_HOLIDAYS,
  TREQUEST_DELETE_HOLIDAYS,
  TREQUEST_EDIT_HOLIDAY,
} from '@monorepo/types';
import * as ConfigSetupActions from './config-setup.actions';
import * as ConfigSetupSelector from './config-setup.selectors';
import { TUserPaginationOption } from '@monorepo/ui';
import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { LOCAL_STORAGE_UTILS } from '@monorepo/utils';

@Injectable({
  providedIn: 'root',
})
export class ConfigSetupFacade {
  constructor(private store: Store<TMachineMaintenanceState>) {
    this.initializeHolidayListPagination();
  }

  initializeHolidayListPagination() {
    const storedPageSize = LOCAL_STORAGE_UTILS.retrieveData('holidayListPageSize');
    if (storedPageSize && LIST_ITEMS_PER_PAGE_LIST.includes(Number(storedPageSize))) {
      this.setHolidayListPagination({
        pageNo: 1,
        pageSize: parseInt(storedPageSize),
      });
    } else {
      LOCAL_STORAGE_UTILS.storeData('holidayListPageSize', LIST_ITEMS_PER_PAGE_LIST[0].toString());
      this.setHolidayListPagination({
        pageNo: 1,
        pageSize: LIST_ITEMS_PER_PAGE_LIST[0],
      });
    }
  }

  setHolidayListPagination(pagination: TUserPaginationOption) {
    LOCAL_STORAGE_UTILS.storeData('holidayListPageSize', pagination.pageSize.toString());
    this.store.dispatch(new ConfigSetupActions.SetHolidayListPagination(pagination));
  }

  resetHolidayListInfo(fetchReason: TListingFetchReason) {
    const pageSize = Number(LOCAL_STORAGE_UTILS.retrieveData('holidayListPageSize') || LIST_ITEMS_PER_PAGE_LIST[0]);
    this.setHolidayListPagination({ pageNo: 1, pageSize });
    this.fetchHolidayListInfo(fetchReason, []);
  }

  fetchHolidayListInfo(fetchReason: TListingFetchReason, selectedFilters: TFilterSelected[]) {
    this.store.dispatch(new ConfigSetupActions.GetHolidayListInfo(fetchReason, selectedFilters));
  }

  addHolidays(holidays: TREQUEST_ADD_HOLIDAYS) {
    return this.store.dispatch(new ConfigSetupActions.AddHolidays(holidays));
  }

  deleteHolidays(holidays: TREQUEST_DELETE_HOLIDAYS) {
    return this.store.dispatch(new ConfigSetupActions.DeleteHolidays(holidays));
  }

  getHolidayListInfo() {
    return this.store.pipe(select(ConfigSetupSelector.getHolidayListInfo));
  }

  getHolidayListPagination() {
    return this.store.pipe(select(ConfigSetupSelector.getHolidayListPagination));
  }

  editHoliday(holiday: TREQUEST_EDIT_HOLIDAY) {
    this.store.dispatch(new ConfigSetupActions.EditHoliday(holiday));
  }
}

export type TGetHolidayListInfo = ReturnType<ConfigSetupFacade['getHolidayListInfo']>;
export type TGetHolidayListPagination = ReturnType<ConfigSetupFacade['getHolidayListPagination']>;
